import { ApplyForEoriCTA } from "./ctas";
export var ApplyForEoriIA = function ApplyForEoriIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return APPLY_FOR_EORI(strictLocalize);
    },
    getDescription: function getDescription() {
      return [EORI_DEFINITION(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize, articles) {
  return ApplyForEoriCTA(strictLocalize, articles);
};
var APPLY_FOR_EORI = function APPLY_FOR_EORI(strictLocalize) {
  return strictLocalize({
    id: "w1hyF6",
    defaultMessage: [{
      "type": 0,
      "value": "Candidate-se para obter o número EORI"
    }]
  });
};
var EORI_DEFINITION = function EORI_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "elnXE+",
    defaultMessage: [{
      "type": 0,
      "value": "Ter um número EORI ajuda a evitar potenciais atrasos e taxas de armazenamento caso as encomendas não possam ser processadas pela alfândega em tempo útil. Por conseguinte, recomendamos que obtenha um número EORI se estiver a importar produtos de outro país. Encontre abaixo as ligações específicas do país para se candidatar ao número EORI."
    }]
  });
};